<template>
  <section class="section">
    <div class="container">
      <!-- https://help.allsecpay.com/knowledgebase.php?article=563ba7d5a3c877fbc24c7d15f6f46ec3#opsti-u -->

      <h1 class="title">Услови куповине</h1>
      <!-- ----------------------------------------------------------------------------- -->
      <h1 class="is-size-4">1. О нама</h1>
      <h2 class="is-size-5">1.1. Основни подаци о компанији</h2>
      <p>
        Јавно предузеће Дирекција за изградњу општине Параћин
        <br />Владике Николаја Велимировића 1 <br />35250 Параћин МБ 17018795
        <br />ПИБ 101094056 <br />тек. рачун 160-0000000462420-13
      </p>
      <br />
      <!-- ----------------------------------------------------------------------------- -->
      <h1 class="is-size-5">2. Политика приватности</h1>
      <h2 class="is-size-5">2.1. Дефиниције политике приватности</h2>
      <p>
        Ова Политика приватности регулише праксу прикупљања информација од
        корисника приликом коришћења интернет странице
        <a href="https://direkcijaparacin.rs">www.direkcijaparacin.rs</a>. Наша
        политика приватности обухвата разлоге како и зашто сакупљамо, користимо
        и штитимо Ваше личне податке. <br /><br />Задржавамо дискреционо право
        да ову Политику приватности можемо изменити у свако доба и да тако
        измењен текст постане важећи одмах по објави истог на Wеб сајту.
        <br /><br />Наставак Вашег коришћења Wеб сајта након измена, подразумева
        да прихватате све услове тако измењене Политике приватности. Стога
        саветујемо кориснике да периодично поново детаљно прочитају информације
        садржане у Политици приватности, како би били информисани о евентуалним
        променама.
      </p>
      <br />
      <h2 class="is-size-5">2.2. Начин прикупљања и употребе података</h2>
      <p>
        Током Ваше посете сајту можемо прикупити ваше личне податке које су
        неопходне да подесите свој налог, у сврху наплате или испоруке Ваше
        робе. Ваше личне податке користимо искључиво и само како би нам
        омогућили да Вам обезбедимо производе и услуге које желите ради
        задовољења Ваших захтева или да Вам прилагодимо нашу понуду, тј. да је
        персонализујемо, унапредили рад Wеб сајта, осигурали проверу
        административних задатака, успоставили контакта са Вама, побољшали наше
        оглашивачке и промотивне резултате и побољшали нашу понуду производа или
        услуга на тржишту, као и у сврху сарадње са институцијама одговорним за
        спровођење закона. <br /><br />Ми не продајемо и не изнајмљујемо Ваше
        личне податке трећим лицима, за њихове маркентишке потребе а да
        претходно нисмо Вама дали могућност да ту опцију искључите. Међутим, ми
        можемо открити Ваше податке нашим пословним јединицама и партнерима,
        који су део ове Политике приватности. Никада и ни под којим условима
        нећемо злоупотребити Ваше личне податке. У следећим одељцима ћемо Вам
        изложити начине и разлоге за могуће давање Ваших информација, за потребе
        нормалног пословања Wеб сајта.
      </p>
      <br />
      <h2 class="is-size-5">2.3. Складиштење и чување података</h2>
      <p>
        Предузеће Дирекција за изградњу општине Параћин као продавац производа и
        услуга на Wеб сајту улаже максималне напоре ради заштите Ваше
        приватности кад сте "online" као корисник. Ваше личне инфрмације се
        чувају на сигуран и поверљив начин, и обрађују на законит начин у складу
        са овом политиком приватности. Предузимамо одговарајуће техничке и
        организационе мере ради заштите од наовлашћеног и незаконитог приступа и
        обраде ваших личних података, укључујући и енкрипцију ваших информација.
        Ми ћемо Ваше информације задржати онолико дуго колико је потребно да
        обрадимо Ваш налог, Ваше плаћање, одрадимо рефундацију средстава,
        одговоримо на жалбу или пружимо Вам промотивне информације на које сте
        се пријавили.
      </p>
      <br />
      <h2 class="is-size-5">2.4. Колачићи (cookies)</h2>
      <p>
        Колачић (цоокие) је информација сачувана на Вашем рачунару од стране
        интернет странице коју посетите. Колачићи обично чувају Ваша подешавања,
        поставке за интернет страницу, као што су преферирани језик или адреса.
        Касније, када опет отворите исту интернет страницу интернет прегледач
        шаље натраг колачиће који припадају тој страници. Ово омогућава страници
        да Вас препозна и прикаже информације прилагођене Вашим потребама.
        Уколико не желите да наш Wеб сајт има приступ Вашим колачићима, можете
        их блокирати. Већина wеб броwсера Вам омогућава да блокирате колачиће.
        То можете урадити путем Подешавања Вашег wеб броwсера.
      </p>
      <br />
      <!-- ----------------------------------------------------------------------------- -->
      <h1 class="is-size-4">3. Општи услови пружања услуга</h1>
      <h2 class="is-size-5">3.1. Општи услови пружања услуга</h2>
      <p>
        Продаја робе путем наше онлине продавнице Дирекција за изградњу општине
        Параћин обавља у оквиру регистроване делатности привредног друштва
        Параћину улица: Владике Николаја Велимировића 1, матични број 17018795.
        <br /><br />Роба (услуге) која се продаје путем Wеб сајта поседује
        својства потребна за редовну употребу те врсте робе у складу са њеном
        наменом. Продајна цена робе је назначена уз сваки артикал Настојимо да
        будемо што прецизнији у опису производа, приказу слика и самих цена, али
        не можемо гарантовати да су све информације комплетне и без грешака.
        Слике не морају бити 100% идентичне производима. Сви артикли приказани
        на сајту су део наше понуде и не подразумева да су доступни у сваком
        тренутку.
      </p>
      <br />
      <!-- ----------------------------------------------------------------------------- -->
      <h1 class="is-size-4">4. Политика испоруке</h1>
      <h2 class="is-size-5">4.1. Тренутак прихватања поруџбине</h2>
      <p>
        Након поручивања, бићете обавештени о статусу Ваше поруџбине путем
        поруке на екрану
      </p>
      <br />
      <h2 class="is-size-5">4.2. Рок испоруке</h2>
      <p>
        Период испоруке поруџбине је одмах
      </p>
      <!-- <h2 class="is-size-5">4.3. Кашњење испоруке</h2>
      <p>
        У случају кашњења испоруке, купац има право да одустане од куповине, и у
        том случају ће сав новац бити враћен.
      </p> -->
      <!-- <h2 class="is-size-5">4.4. Цена испоруке</h2>
      <p>
        Цена испоруке Наручену робу Вам шаљемо курирском службом
        .................., цена испоруке је .................. динара за све
        купце у [ДРЖАВА]. Трошкови испоруке се додају на цену производа и
        исказани су уз цену производа и током процеса наручивања на Wеб сајту. У
        случају замене робе, трошкове враћања робе сноси ............... Можемо
        поделити Вашу поруџбину приликом испоруке на неколико делова у
        зависности од расположивости и доступности робе на залихама (може се
        десити да је у некој другој радњи или магацину у другом граду). То купцу
        неце проузроковати никакве додатне трошкове.
      </p> -->
      <!-- <h2 class="is-size-5">4.5. Процедура испоруке</h2>
      <p>
        Пошиљка стиже на адресу у периоду од ....-... сати. Потребно је да у том
        периоду на адреси буде особа која може преузети пошиљку. Курир сваку
        пошиљку покушава да уручи у два наврата. Уколико Вас курир не пронађе на
        адреси, позваће вас на телефон који сте оставили приликом креирања
        поруџбенице и договорити нови термин испоруке. Уколико Вас ни други пут
        не пронађе на адреси, пошиљка се враћа у наше просторије . Приликом
        преузимања пошиљке потребно је визуелно прегледати пакет, да не постоаје
        случајно видна оштећења. Уколико приметите да је транспорнта кутија
        значајно оштећена и посумњате да је производ можда оштећен, имате права
        да одбијете пријем пошиљке и одмах нас обавестите позивом на телефон
        ............. или путем емаила ........... . Уколико је пошиљка на
        изглед без оштећења слободно преузмите пошиљку и потпишите куриру
        адресницу.
      </p> -->
      <br />
      <!-- ----------------------------------------------------------------------------- -->
      <h1 class="is-size-4">5. Политика плаћања</h1>
      <h2 class="is-size-5">5.1. Начини плаћања</h2>
      <p>
        Плаћање производа на нашој интернет продавници је могуће извршити на
        један од следећих начина: платним картицама - VISA, Maestro или
        MasterCard које подржавају плаћање преко Интернета. Плаћање картицама је
        реализовано у сарадњи са AllSecure доо и UniCredit банком и обавља се на
        безбедан и сертификован начин преко AllSecure Paymet Gateway-а,
        једноставним уносом података са платне картице. Након што се унесу
        подаци о картици и потврди плаћање, банка ауторизује трансакцију и тиме
        је поруџбина одобрена и улази у даљи процес припреме за испоруку. Износ
        ће бити резервисан на вашој картици (рачуну) и неће Вам бити расположив
        за другу намену. Транскација ће бити комплетирана и износ скинут са
        вашег рачуна тек када су производи припремљени за транспорт и предати
        курирској служби. У случају да се плаћање не комплетира, односно износ
        се не скине са рачуна до истека 14 дана од прихватања Ваше поруџбине, та
        поруџбеница ће бити отказана и избрисана. Након истека рока од 14 дана ,
        новац резервисане на Вашем рачуну се ослобадјају и биће Вам поново на
        располагању. Након тога можете поновити исту или нову поруџбину, и
        извршити плаћање везано за њих. Проверите код банке која је картицу
        издала да ли Ваша картица подржава плаћање преко Интернета.
      </p>
      <br />
      <h2 class="is-size-5">
        5.2. Заштита података приликом плаћања картицама
      </h2>
      <p>
        Приликом уношења података о платној картици, поверљиве информације се
        преносе путем јавне мреже у заштићеној (криптованој) форми употребом SSL
        протокола, применом најсавременијих метода токенизације осетљивих
        података, и у складу са PCI-DSS стандардима. Нити једног тренутка подаци
        о платној картици нису доступни трговцу.<br /><br />
        Приликом уношења података о платној картици, поверљиве информације се
        преносе путем јавне мреже у заштићеној (криптованој) форми употребом SSL
        протокола, применом најсавременијих метода токенизације осетљивих
        података, и у складу са PCI-DSS стандардима. Нити једног тренутка подаци
        о платној картици нису доступни трговцу.
        <br /><br />
        3D Secure заштита за све трговце и купце - AllSecure Payment Gateway
        користи највише глобалне стандарде заштите и приватности података. Сви
        трговци који користе AllSecure Payment Gateway су аутоматски укључени у
        3Д-Сецуре заштиту, чиме се купцима гарантује безбедност куповине.
        Бројеви платних картица купаца се не чувају на систему трговца а сами
        упис се штити SSL енкрипцијом података.
        <br /><br />
        PCI DSS Стандарди - AllSecure Payment Gateway се константно усаглашава
        са свим захтевима картичарских организација у циљу повећања нивоа
        безбедности трговаца и купаца. Од 2005 године до данас, без прекида,
        систем је сертификован као PCI-DSS Левел 1 што представља највиши
        стандард у индустрији. PCI Data Security Standard (PCI-DSS) је норма
        која дефинише неопходне мере безбедности при обради, чувању и преношењу
        осетљивих картичарских података. PCI Стандардима се штите осетљиви
        подаци о кориснику картице током целог процеса плаћања: од момента уноса
        података на продајном месту трговца, током комуникација између трговца и
        релевантних банака и картичарских организација, као и касније чување тих
        података.
      </p>
      <br />
      <h2 class="is-size-5">5.3. Изјава о конверзијама</h2>
      <p>
        Сва плаћања ће бити обављенима у динарима (РСД). Уколико се плаћа
        платним картицама иностраних Банака издавалаца, динарски износ
        трансакције ће бити конвертован у сеттлемент валуту Банке (ЕУР) према
        курсу Народне Банке Србије. При задуживању Васе платне картице, већ
        конвертован износ ће се конвертовати у Васу локалну валуту, према курсу
        који примењују оператори платних картица.
      </p>
      <br />
      <h2 class="is-size-5">5.4. Повраћај средстава</h2>
      <p>
        У случају повраћаја средстава купцу који је предходно платио неком од
        платних картица, делимично или у целости, а без обзира на разлог
        враћања, тај повраћај се врши искључиво преко исте VISA, Maestro или
        MasterCard картице која је кориштена за плаћање. Ово значи да ће наша
        банка на наш захтев обавити повраћај средстава на рачун корисника
        картице.
      </p>
      <br />
      <!-- ----------------------------------------------------------------------------- -->
      <h1 class="is-size-4">6. Политика рекламације</h1>
      <h2 class="is-size-5">6.1. Поступак рекламације</h2>
      <p>
        Производи који се продају путем наше интернет продавнице, су праћени
        свом законски неопходном документацијом укључујући и гарантне листове
        произвођача. Уколико се појави потреба да рекламирате одређени артикал
        на квалитет ми ћемо испунити све законски дефинисане обавезе за
        продавца, на исти начин као да сте робу купили у класичној продавници.
        <br /><br />Роба покривена гаранцијом произвођача се продаје са
        гаранцијом произвођача проширена на Купца. Рекламациони поступак се
        покреће на захтев купца, попуњавањем Захтева за рекламацију на квалитет
        производа . <br /><br />Уколико желите да започнете процес рекламације,
        потребно је да нам се обратите на емаил direkcijaparacin@gmail.com или
        телефоне +38135564369, +381631076990 <br /><br />Предузеће Јавно
        предузеће Дирекција за изградњу општине Параћин не преузима никакву
        одговорност за грешке купаца, производе погрешно купљене или било које
        друге грешке које се односе на Ваше поступке приликом куповине на Wеб
        сајту. Уколико имате неправилности у раду приликом куповине производа на
        Wеб сајту или нисте добили купљени производ, молимо Вас да контактирате
        кориснички сервис (контакт подаци) и ми ћемо се потрудити да отклонимо
        неправилности како бисте добили купљени производ. <br /><br />Ако је
        неки производ који сте купили дефектан или не функционише правилно из
        било ког разлога, молимо Вас да контактирате наш кориснички сервис
        (контакт подаци) и да погледате гарантни лист како бисте се упознали са
        детаљима гаранције и поступком рекламације.
      </p>
      <br />
      <h2 class="is-size-5">6.2. Право на повраћај новца или замену робе</h2>
      <p>
        У случају одустанка од уговора, потрошач има право на повраћај новца или
        на замену за други производ. Избнос се купцу враћа по пријему производа,
        и након што се утврди да је производ враћен неоштећен и исправан.
      </p>
      <br />
      <h2 class="is-size-5">
        6.3. Право на одустајање од уговора, права и обавезе купца и продавца
      </h2>
      <p>
        Закон за случај продаје на даљину установљава право купца, који се
        сматра потрошачем (физичко лице које производ купује ради намирења
        својих индивидуалних потреба, а не ради обављања професионалне
        делатности), да одустане од уговора у року од 14 дана од дана када му је
        производ предат. Приликом одустанка купац може, али не мора да наведе
        разлоге због којих одустаје. Образац/Изјава о одустанку од уговора
        производи правно дејство од дана када је послата трговцу. У случају
        одустанка од уговора, потрошач има право на повраћај новца или на замену
        за други производ. Цена се купцу враћа по пријему производа, и након што
        се утврди да је производ неоштећен и исправан. Купац је дужан да
        производ врати без одлагања, а најкасније у року од 14 дана од дана када
        је послао образац за одустанак. По истеку рока од 14 дана од дана када
        је послао одустанак, производ се више не мозе вратити. Приликом
        повраћаја робе обавезно је вратити у исправном и некоришћеном стању и
        оригинално неоштећеном пакавању, при чему се мора приложити и оригинални
        фискални исечак. По пријему производа, утврдиће се да ли је производ
        исправан и неоштећен. Купац одговара за неисправност или оштећење
        производа који су резултат неадекватног руковања производом, тј. купац
        је искључиво одговоран за умањену вредност производа која настане као
        последица руковања робом на начин који није адекватан, односно
        превазилази оно што је неопходно да би се установили његова природа,
        карактеристике и функционалност. Уколико се утврди да је наступила
        неисправност или оштећење производа кривицом купца, одбиће се враћање
        цене и производ ће му бити враћен на његов трошак. Трговац је дужан да
        потрошачу без одлагања врати износ који је потрошач платио по основу
        уговора, а најкасније у року од 14 дана од дана пријема изјаве о
        одустанку, а након пријема производа.
      </p>
      <br />
      <h2 class="is-size-5">6.4. Трошкови враћања робе и новца</h2>
      <p>
        Трошкове враћања робе и новца сноси купац, сем у случајевима када купац
        добије неисправан или погрешан артикал.
      </p>
      <br />
      <!-- ----------------------------------------------------------------------------- -->
      <h2 class="is-size-4">
        7.1. Упутство за куповину - поступак куповине
      </h2>
      <p>
        Све артикле које смо приказали на нашој интернет продавници
        <a href="https://direkcijaparacin.rs">www.direkcijaparacin.rs</a> можете
        поручити, на врло брз и једноставан начин. Све што је потребно да
        урадите је да пронађете артикал који желите, и оставите своје податке
        <br /><br />Након што приступите нашем сајту, пређите на претрагу
        артикала. Како бисте убрзали и олакшали своју претрагу можете користити
        филтере. <br /><br />Када се одлучите за неки артикал ставите га у
        корпу. Када то урадите у горњем делу екрана ће се појавити нови прозор
        који вам нуди могућност да видите ствари које се налазе у корпи, као и
        могућност директног одласка на касу. <br /><br />Уколико сте завршили
        процес избора производа, кликните на опцију ">>" како бисте отворили
        ново поље у које треба да унесете податке о себи. Након уноса података
        кликните на опцију ">>" како бисте прешли на следећи корак.
        <br /><br />Наредна ствар коју треба да урадите јесте да проверите
        поруџбеницу, односно да утврдите да ли сте поручили све ствари које сте
        желели или сте можда изоставили неки артикал, погрешили у броју или
        величини. На екрану ће вам се појавити подаци свих артикала које сте
        претходно "ставили у корпу". Уколико су сви подаци исправни, идете на
        потврду (Изврши плаћање). <br /><br />Појавиће вам се поља у коју морате
        да унесете следеће податке: број картице, име власника картице, датум
        истека картице и CVV број картице (односно верификациони број картице) -
        то је број који обично стоји на полеђини картице, након број картице
        (може да буде приказан комплетан број картице са 16 цифара или само
        задње 4 цифре) стоји посебан код који се обично састоји од 3 цифре (код
        неких картица има и са 4 цифре), и тај троцифрени број је ваш CVV број
        картице. Евентуално може вам се тражити да унесете тип картице.
        <br /><br />У следећем кораку, појавиће вам се потврда куповние коју
        можете одштампати или једноставно забележити податке о трансакцији –
        информације о статусу трансакције (да ли је трансакција успела или не),
        ИД број поруџбине - ИД број сваке поруџбенице је јединствен , износ који
        сте платили и валуту у којој је трансакција обављена, задње 4 цифре
        картице са којом сте извршили плаћање и тип или бранд картице,
        ауторизациони код банке – број јединствен за сваку успешну картичну
        трансакцију, и датум и време када је трансакција извршена.
        <br /><br />Овим кораком се завршава процесс онлине куповине. Након
        тога, бићете обавештени о статусу Ваше поруџбине <br /><br />Уколико у
        току процеса наручивања будете имали било какав проблем, увек нас можете
        контактирати на наведене контакте
      </p>
      <br />
      <div class="columns">
        <div class="column">
          <a class="button is-pulled-right" @click="$router.go(-1)">Назад</a>
        </div>
      </div>

      <Footer />
    </div>
  </section>
</template>

<script>
// import LinkovaniLogotipovi from '@/components/LinkovaniLogotipovi.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    // LinkovaniLogotipovi,
    Footer
  }
}
</script>

<style>
h2 {
  margin-left: 16px;
}

p {
  margin-left: 32px;
}
</style>
